import { Product } from './productModels';

// Exporting PROTEIN_LABELS as it is used by ArticleCard
export const PROTEIN_LABELS: Record<string, { en: string; zh: string }> = {
  Chicken: { en: 'Chicken', zh: '雞肉' },
  Salmon: { en: 'Salmon', zh: '三文魚' },
  Beef: { en: 'Beef', zh: '牛肉' },
  Lamb: { en: 'Lamb', zh: '羊肉' },
  Duck: { en: 'Duck', zh: '鴨肉' },
  Turkey: { en: 'Turkey', zh: '火雞' },
};

const MOCK_PRODUCTS: Product[] = [
  {
    id: 'p-001',
    slug: 'freeze-dried-chicken',
    slugs: {
      en: 'freeze-dried-chicken',
      'zh-hk': 'freeze-dried-chicken-hk',
      'zh-cn': 'freeze-dried-chicken-cn',
    },
    status: 'active',
    tier: 'Single Ingredient',
    pet: 'both',
    primaryProtein: 'Chicken',
    priority: 0,
    featured: true,
    name: {
      en: 'Freeze-Dried Chicken Breast',
      'zh-hk': '凍乾雞胸肉',
      'zh-cn': '冻干鸡胸肉',
    },
    shortDesc: {
      en: '100% pure chicken breast. No preservatives.',
      'zh-hk': '100% 純雞胸肉，無防腐劑。',
      'zh-cn': '100% 纯鸡胸肉，无防腐剂。',
    },
    highlights: {
      en: ['100% Single Ingredient', 'No Additives', 'Freeze-Dried Raw'],
      'zh-hk': ['100% 單一成分', '無添加', '生肉凍乾'],
      'zh-cn': ['100% 单一成分', '无添加', '生肉冻干'],
    },
    ingredients: {
      en: ['100% Chicken Breast'],
      'zh-hk': ['100% 雞胸肉'],
      'zh-cn': ['100% 鸡胸肉'],
    },
    tags: ['chicken', 'treat', 'topper'],
    cover: '', // Placeholder
    images: [],
    description: {
      en: '',
      'zh-hk': '',
      'zh-cn': '',
    },
    prices: {
      HKD: { priceCents: 12800, compareAtCents: null },
      USD: { priceCents: 1650, compareAtCents: null },
      GBP: { priceCents: 1299, compareAtCents: null },
    },
    stockOnHand: 100,
    reservedQty: 0,
  },
  {
    id: 'p-002',
    slug: 'freeze-dried-salmon',
    slugs: {
      en: 'freeze-dried-salmon',
      'zh-hk': 'freeze-dried-salmon-hk',
      'zh-cn': 'freeze-dried-salmon-cn',
    },
    status: 'active',
    tier: 'Single Ingredient',
    pet: 'both',
    primaryProtein: 'Salmon',
    priority: 1,
    featured: false,
    name: {
      en: 'Freeze-Dried Salmon Cubes',
      'zh-hk': '凍乾三文魚丁',
      'zh-cn': '冻干三文鱼丁',
    },
    shortDesc: {
      en: 'Rich in Omega-3. Wild-caught.',
      'zh-hk': '豐富 Omega-3，野生捕撈。',
      'zh-cn': '丰富 Omega-3，野生捕捞。',
    },
    highlights: {
      en: ['Rich in Omega-3', 'Skin & Coat Support', 'Wild Caught'],
      'zh-hk': ['豐富 Omega-3', '皮毛健康', '野生捕撈'],
      'zh-cn': ['丰富 Omega-3', '皮毛健康', '野生捕捞'],
    },
    ingredients: {
      en: ['100% Salmon'],
      'zh-hk': ['100% 三文魚'],
      'zh-cn': ['100% 三文鱼'],
    },
    tags: ['salmon', 'fish', 'skin'],
    cover: '',
    images: [],
    description: {
      en: '',
      'zh-hk': '',
      'zh-cn': '',
    },
    prices: {
      HKD: { priceCents: 13800, compareAtCents: 15800 },
      USD: { priceCents: 1799, compareAtCents: 2000 },
      GBP: { priceCents: 1450, compareAtCents: null },
    },
    stockOnHand: 50,
    reservedQty: 0,
  },
  {
    id: 'p-003',
    slug: 'chicken-functional-support',
    slugs: {
      en: 'chicken-functional-support',
      'zh-hk': 'chicken-functional-support-hk',
      'zh-cn': 'chicken-functional-support-cn',
    },
    status: 'active',
    tier: 'Functional',
    pet: 'dog',
    primaryProtein: 'Chicken',
    priority: 2,
    featured: false,
    name: {
      en: 'Chicken + Functional Support',
      'zh-hk': '雞肉 + 機能配方',
      'zh-cn': '鸡肉 + 机能配方',
    },
    shortDesc: {
      en: 'Gentle digestion support with minimal ingredients.',
      'zh-hk': '溫和消化配方，極簡成分。',
      'zh-cn': '温和消化配方，极简成分。',
    },
    highlights: {
      en: ['Primary protein is chicken', 'Minimal functional ingredients', 'Vet formulated'],
      'zh-hk': ['雞肉為主要蛋白', '極簡機能成分', '獸醫配方'],
      'zh-cn': ['鸡肉为主要蛋白', '极简机能成分', '兽医配方'],
    },
    ingredients: {
      en: [],
      'zh-hk': [],
      'zh-cn': [],
    },
    tags: ['chicken', 'digestion', 'functional'],
    cover: '',
    images: [],
    description: {
      en: '',
      'zh-hk': '',
      'zh-cn': '',
    },
    prices: {
      HKD: { priceCents: 15800, compareAtCents: null },
      USD: { priceCents: 1999, compareAtCents: null },
      GBP: { priceCents: 1599, compareAtCents: null },
    },
    stockOnHand: 0,
    reservedQty: 0,
  },
];

export const PRODUCTS = MOCK_PRODUCTS;

export const getProductBySlug = (slug: string): Product | undefined => {
  return PRODUCTS.find(p => p.slug === slug && p.status === 'active');
};

export const getProductsBySlugs = (slugs: string[]): Product[] => {
  if (!slugs || slugs.length === 0) return [];
  return PRODUCTS.filter(p => slugs.includes(p.slug) && p.status === 'active');
};

export const listActiveProducts = (): Product[] => {
  return PRODUCTS.filter(p => p.status === 'active').sort((a, b) => {
    // 1. Featured first
    if (a.featured && !b.featured) return -1;
    if (!a.featured && b.featured) return 1;

    // 2. Priority ASC (0, 1, 2...)
    const priorityDiff = (a.priority || 0) - (b.priority || 0);
    if (priorityDiff !== 0) return priorityDiff;

    // 3. Name EN ASC (Stable fallback)
    return a.name.en.localeCompare(b.name.en);
  });
};
